import React from 'react';

export default function KoobPlaceholder({ className }) {
  return <div className={['animate-pulse bg-gray-200', className].join(' ')} />;
}
